<template>
  <q-page class="flex column page-layout help">
    <StrapiContent strapiUrl="client-portal-documentations/1" />
    <StrapiContent strapiUrl="client-portal-documentations/2" />
  </q-page>
</template>

<script>
import StrapiContent from "@/components/content/StrapiContent.vue";
export default {
  name: "Help",
  components: {
    StrapiContent,
  },
};
</script>
